export const isValidBrandHex = (hex: string): boolean => /^#[0-9A-F]{6}$/i.test(hex);
